import { render } from "./RecordMixin.vue?vue&type=template&id=716fc2b6"
import script from "./RecordMixin.vue?vue&type=script&lang=js"
export * from "./RecordMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__